import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, vModelText as _vModelText, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-85da8664"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tournamentMatch" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "center display-2" }, "Kampseddel", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Bemærk: Dem der benytter kamptavlen, skal først sætte hold og begynde kampen på den ene tablet (ikke på dem begge!). Når kampen er blevet begyndt, kan man så efterføglende åbne kampseddlen på den anden tablet og starte en kamp.", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "row justify--center"
}
const _hoisted_11 = { class: "flex ml-2 mr-2" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Test tjek lovlige spillere")
const _hoisted_14 = { class: "flex ml-2 mr-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Log Hold Data")
const _hoisted_16 = { class: "flex ml-2 mr-2" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Udskriv kampseddel")
const _hoisted_18 = {
  key: 2,
  class: "row justify--space-around"
}
const _hoisted_19 = { class: "flex mb-4" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("Sæt hjemmehold")
const _hoisted_21 = { class: "flex mb-4" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Sæt udehold")
const _hoisted_23 = {
  key: 3,
  class: "row justify--space-around"
}
const _hoisted_24 = { class: "flex mb-4" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Nulstil holdene")
const _hoisted_26 = {
  key: 4,
  class: "row justify--space-around mt-2 mb-4"
}
const _hoisted_27 = { class: "flex teamBox md3" }
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = { class: "flex teamBox md3" }
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = {
  key: 5,
  class: "row justify--center"
}
const _hoisted_32 = { class: "flex md6 center" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("Vælg holdkaptajn")
const _hoisted_34 = {
  key: 6,
  class: "row justify--center"
}
const _hoisted_35 = { class: "flex md6 center" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("Begynd kampen")
const _hoisted_37 = {
  key: 7,
  class: "row justify--center mt-2"
}
const _hoisted_38 = { class: "flex md6 center" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode("Start Match")
const _hoisted_40 = {
  key: 8,
  class: "va-table-responsive"
}
const _hoisted_41 = { class: "va-table matchCardTable" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", { colspan: "3" })
], -1))
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Kampnr.: ")
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Runde: ")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("Række: ")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Godkend & afslut kampen")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Kampdato: ")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Hjemmehold: ")
const _hoisted_49 = { class: "center" }
const _hoisted_50 = /*#__PURE__*/_createTextVNode("Resultat: ")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Kampstart: ")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Udehold: ")
const _hoisted_53 = { class: "center" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Resultat: ")
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_56 = {
  key: 9,
  class: "matchCardTable center"
}
const _hoisted_57 = {
  key: 10,
  class: "va-table-responsive"
}
const _hoisted_58 = { class: "va-table matchCardTable" }
const _hoisted_59 = {
  colspan: 8,
  class: "ml-2 mt-2"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Navn"),
  /*#__PURE__*/_createElementVNode("th", null, "Overall Snit"),
  /*#__PURE__*/_createElementVNode("th", null, "Licens"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Vundne kampe"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Vundne sæt"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Tabte sæt"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "center",
    style: {"width":"10%"}
  }, "180"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Højeste lukker"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Hurtigste sæt")
], -1))
const _hoisted_61 = { class: "center" }
const _hoisted_62 = { class: "center" }
const _hoisted_63 = { class: "center" }
const _hoisted_64 = { class: "center" }
const _hoisted_65 = { class: "center" }
const _hoisted_66 = { class: "center" }
const _hoisted_67 = { class: "center" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_69 = {
  key: 11,
  class: "va-table-responsive"
}
const _hoisted_70 = { class: "va-table matchCardTable" }
const _hoisted_71 = {
  colspan: 8,
  class: "ml-2 mt-2"
}
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Navn"),
  /*#__PURE__*/_createElementVNode("th", null, "Overall Snit"),
  /*#__PURE__*/_createElementVNode("th", null, "Licens"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Vundne kampe"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Vundne sæt"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Tabte sæt"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "center",
    style: {"width":"10%"}
  }, "180"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Højeste lukker"),
  /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Hurtigste sæt")
], -1))
const _hoisted_73 = { class: "center" }
const _hoisted_74 = { class: "center" }
const _hoisted_75 = { class: "center" }
const _hoisted_76 = { class: "center" }
const _hoisted_77 = { class: "center" }
const _hoisted_78 = { class: "center" }
const _hoisted_79 = { class: "center" }
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_81 = {
  key: 12,
  class: "va-table-responsive"
}
const _hoisted_82 = { class: "va-table matchCardTable" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Kamp"),
    /*#__PURE__*/_createElementVNode("th", null, "Navn"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Resultater"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Avanceret"),
    /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Resultater"),
    /*#__PURE__*/_createElementVNode("th", null, "Navn")
  ])
], -1))
const _hoisted_84 = { class: "" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_90 = { key: 2 }
const _hoisted_91 = { class: "va-table-responsive" }
const _hoisted_92 = {
  class: "va-table",
  style: {"width":"100%","--va-form-element-default-width":"96px"}
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Snit")
], -1))
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, "Rest", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, "Dart", -1))
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, "Lukket", -1))
const _hoisted_97 = { class: "center matchSetTable" }
const _hoisted_98 = { style: {"white-space":"nowrap"} }
const _hoisted_99 = /*#__PURE__*/_createTextVNode("*")
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "matchInput",
    type: "number",
    readonly: true
  })
], -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "matchInput",
    type: "number",
    readonly: true
  })
], -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "matchInput",
    type: "number",
    readonly: true
  })
], -1))
const _hoisted_103 = { class: "center matchSetTable" }
const _hoisted_104 = { key: 3 }
const _hoisted_105 = { class: "va-table-responsive" }
const _hoisted_106 = {
  class: "va-table",
  style: {"width":"100%","--va-form-element-default-width":"96px"}
}
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan snit-column" }, "Snit")
], -1))
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Rest")
], -1))
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Dart")
], -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Lukket")
], -1))
const _hoisted_111 = { class: "center matchSetTable" }
const _hoisted_112 = { style: {"white-space":"nowrap"} }
const _hoisted_113 = /*#__PURE__*/_createTextVNode("*")
const _hoisted_114 = {
  key: 0,
  class: "center matchSetTable snit-column"
}
const _hoisted_115 = {
  key: 1,
  class: "center matchSetTable"
}
const _hoisted_116 = ["onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled", "readonly"]
const _hoisted_117 = {
  key: 2,
  class: "center matchSetTable"
}
const _hoisted_118 = ["onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled", "readonly"]
const _hoisted_119 = {
  key: 3,
  class: "center matchSetTable"
}
const _hoisted_120 = ["onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled", "readonly"]
const _hoisted_121 = {
  key: 4,
  class: "center matchSetTable"
}
const _hoisted_122 = {
  key: 0,
  class: "va-table-responsive"
}
const _hoisted_123 = {
  class: "va-table",
  style: {"width":"100%","--va-form-element-default-width":"32px"}
}
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, "Tavle")
  ])
], -1))
const _hoisted_125 = {
  key: 0,
  class: "center matchSetTable"
}
const _hoisted_126 = /*#__PURE__*/_createTextVNode("Afvikle")
const _hoisted_127 = {
  key: 0,
  class: "center matchSetTable"
}
const _hoisted_128 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_129 = { key: 1 }
const _hoisted_130 = {
  class: "va-table",
  style: {"width":"100%","--va-form-element-default-width":"32px"}
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr")
], -1))
const _hoisted_132 = {
  key: 0,
  class: "center matchSetTable"
}
const _hoisted_133 = /*#__PURE__*/_createTextVNode("Live")
const _hoisted_134 = {
  key: 0,
  class: "center matchSetTable"
}
const _hoisted_135 = /*#__PURE__*/_createTextVNode("Detaljer")
const _hoisted_136 = { key: 4 }
const _hoisted_137 = { class: "va-table-responsive" }
const _hoisted_138 = {
  class: "va-table",
  style: {"width":"100%","--va-form-element-default-width":"96px"}
}
const _hoisted_139 = { class: "center matchSetTable" }
const _hoisted_140 = { style: {"white-space":"nowrap"} }
const _hoisted_141 = /*#__PURE__*/_createTextVNode("*")
const _hoisted_142 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Lukket")
], -1))
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Dart")
], -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Rest")
], -1))
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Snit")
], -1))
const _hoisted_146 = { class: "center matchSetTable" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "matchInput",
    type: "number",
    readonly: true
  })
], -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "matchInput",
    type: "number",
    readonly: true
  })
], -1))
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "matchInput",
    type: "number",
    readonly: true
  })
], -1))
const _hoisted_150 = { key: 5 }
const _hoisted_151 = { class: "va-table-responsive" }
const _hoisted_152 = {
  class: "va-table",
  style: {"width":"100%","--va-form-element-default-width":"96px"}
}
const _hoisted_153 = { class: "center matchSetTable" }
const _hoisted_154 = { style: {"white-space":"nowrap"} }
const _hoisted_155 = /*#__PURE__*/_createTextVNode("*")
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Lukket")
], -1))
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Dart")
], -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan" }, "Rest")
], -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center matchSetTable" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "matchSetTableHeadSpan snit-column" }, "Snit")
], -1))
const _hoisted_160 = {
  key: 0,
  class: "center matchSetTable snit-column"
}
const _hoisted_161 = {
  key: 1,
  class: "center matchSetTable"
}
const _hoisted_162 = ["onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled", "readonly"]
const _hoisted_163 = {
  key: 2,
  class: "center matchSetTable"
}
const _hoisted_164 = ["onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled", "readonly"]
const _hoisted_165 = {
  key: 3,
  class: "center matchSetTable"
}
const _hoisted_166 = ["onUpdate:modelValue", "onChange", "onKeyup", "error", "disabled", "readonly"]
const _hoisted_167 = {
  key: 4,
  class: "center matchSetTable"
}
const _hoisted_168 = { key: 6 }
const _hoisted_169 = { key: 7 }
const _hoisted_170 = ["onClick"]
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_173 = { class: "tableDivider" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_179 = { class: "center display-6" }
const _hoisted_180 = { class: "layout gutter--xl" }
const _hoisted_181 = { class: "row justify--center" }
const _hoisted_182 = { class: "flex md6" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex md6" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Advarsel:"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Alle felter for kun dette hold og kun denne ene kamp vil blive nulstillet ved opdateringen, når markeringsfeltet for \"blev syg\" er sat. ")
  ])
], -1))
const _hoisted_184 = { class: "row justify--center" }
const _hoisted_185 = { class: "flex" }
const _hoisted_186 = /*#__PURE__*/_createTextVNode("Opdater")
const _hoisted_187 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "display-6 center mb-2" }, "Udskriv kampseddel", -1))
const _hoisted_189 = { class: "layout gutter--xl" }
const _hoisted_190 = { class: "row justify--center align--center" }
const _hoisted_191 = { class: "flex md4 matchCardPrintoutOptions" }
const _hoisted_192 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Vælg udskriftsvariant:", -1))
const _hoisted_193 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_194 = { class: "row justify--center" }
const _hoisted_195 = { class: "flex" }
const _hoisted_196 = /*#__PURE__*/_createTextVNode("Fortsæt")
const _hoisted_197 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_198 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6" }, "Opdaterer, vent venligst ...", -1))
const _hoisted_199 = { class: "layout gutter--xl" }
const _hoisted_200 = { class: "row justify--center" }
const _hoisted_201 = { class: "flex md6" }
const _hoisted_202 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6" }, "Advarsel!", -1))
const _hoisted_203 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex md10" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "va-text-justify" }, "Ønsker du virkeligt at nulstille holdenes spillere?"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createElementVNode("p", { class: "va-text-justify" }, "Bemærk at kampseddelsiden automatisk burde genindlæse siden efter 10 sekunder, hvis der vælges at nulstille holdene. Hvis der af en eller anden grund ikke sker en genindlæsning af siden, så prøv at gøre det selv manuelt.")
    ])
  ])
], -1))
const _hoisted_204 = { class: "layout gutter--xl" }
const _hoisted_205 = { class: "row justify--center" }
const _hoisted_206 = { class: "flex" }
const _hoisted_207 = /*#__PURE__*/_createTextVNode("Ja, nulstil")
const _hoisted_208 = { class: "flex" }
const _hoisted_209 = /*#__PURE__*/_createTextVNode("Annullere")
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6" }, "Advarsel!", -1))
const _hoisted_211 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "layout gutter--xl" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "flex md10" }, [
      /*#__PURE__*/_createElementVNode("p", { class: "va-text-justify" }, "Kun en bruger bør ændre værdier i dette felt på samme tidspunkt, for at undgå at man overskriver hinandens ændringer på en uhensigtsmæssigt måde.")
    ])
  ])
], -1))
const _hoisted_212 = { class: "layout gutter--xl" }
const _hoisted_213 = { class: "row justify--center" }
const _hoisted_214 = { class: "flex" }
const _hoisted_215 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_216 = { class: "center display-6" }
const _hoisted_217 = { class: "layout gutter--xl" }
const _hoisted_218 = { class: "flex md2" }
const _hoisted_219 = { class: "flex md10" }
const _hoisted_220 = { class: "layout gutter--xl" }
const _hoisted_221 = { class: "row justify--center" }
const _hoisted_222 = {
  key: 0,
  class: "flex"
}
const _hoisted_223 = /*#__PURE__*/_createTextVNode("Begynd kamp")
const _hoisted_224 = { class: "flex" }
const _hoisted_225 = /*#__PURE__*/_createTextVNode("Luk")
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "center display-6" }, "Vælg holdkaptajn", -1))
const _hoisted_227 = {
  class: "layout gutter--xl",
  style: {"min-height":"200px"}
}
const _hoisted_228 = { style: {"display":"flex","flex-wrap":"nowrap","padding-inline":"10px"} }
const _hoisted_229 = { class: "layout gutter--xl" }
const _hoisted_230 = { class: "row justify--center" }
const _hoisted_231 = { class: "flex" }
const _hoisted_232 = /*#__PURE__*/_createTextVNode("Vælg holdkaptajn")
const _hoisted_233 = { class: "flex" }
const _hoisted_234 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_235 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "center display-4" }, "Godkend og afslut kamp", -1))
const _hoisted_236 = { class: "layout gutter--xl" }
const _hoisted_237 = { class: "row" }
const _hoisted_238 = { class: "flex md12" }
const _hoisted_239 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  class: "center",
  style: {"padding-top":"4px","padding-bottom":"4px","color":"#ff0000"}
}, [
  /*#__PURE__*/_createElementVNode("b", null, "Advarsel!")
], -1))
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "center",
  style: {"padding-top":"4px","padding-bottom":"8px"}
}, " Før man forsøger at godkende denne kampseddel, bør man først genopfriske siden i browseren mindst en gang. Dette kan nemt gøres ved at klikke på følgende knap: ", -1))
const _hoisted_242 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_243 = { class: "center justify--center" }
const _hoisted_244 = /*#__PURE__*/_createTextVNode("Genindlæs siden")
const _hoisted_245 = {
  class: "my-8",
  style: {"padding-top":"8px","padding-bottom":"8px"}
}
const _hoisted_246 = {
  key: 0,
  class: "row"
}
const _hoisted_247 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md12" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Der blev konstateret fejl i kampseddlen:")
  ])
], -1))
const _hoisted_248 = [
  _hoisted_247
]
const _hoisted_249 = { class: "flex md12" }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_251 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_252 = {
  key: 1,
  class: "row"
}
const _hoisted_253 = { class: "flex md12" }
const _hoisted_254 = { class: "center" }
const _hoisted_255 = /*#__PURE__*/_createTextVNode("Bemærkinger: ")
const _hoisted_256 = { class: "center justify--center flex md12" }
const _hoisted_257 = {
  key: 2,
  class: "row"
}
const _hoisted_258 = {
  class: "flex md12",
  style: {"display":"none"}
}
const _hoisted_259 = { class: "row justify--center" }
const _hoisted_260 = { class: "flex" }
const _hoisted_261 = /*#__PURE__*/_createTextVNode("Godkend")
const _hoisted_262 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_263 = { class: "display-4 center" }
const _hoisted_264 = { class: "layout gutter--xl" }
const _hoisted_265 = { class: "row justify--center align--center teamModal" }
const _hoisted_266 = { class: "flex" }
const _hoisted_267 = { class: "flex" }
const _hoisted_268 = /*#__PURE__*/_createTextVNode("Tilføj spiller")
const _hoisted_269 = { class: "flex" }
const _hoisted_270 = { class: "flex md1" }
const _hoisted_271 = ["onClick"]
const _hoisted_272 = ["onClick"]
const _hoisted_273 = { class: "flex md1" }
const _hoisted_274 = { class: "center" }
const _hoisted_275 = { class: "flex md5" }
const _hoisted_276 = { class: "flex md1" }
const _hoisted_277 = ["onClick"]
const _hoisted_278 = { class: "row justify--center" }
const _hoisted_279 = { class: "flex" }
const _hoisted_280 = /*#__PURE__*/_createTextVNode("Sæt hold")
const _hoisted_281 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_282 = { class: "pdf-item" }
const _hoisted_283 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "center pdfHeadline" }, "Kampseddel", -1))
const _hoisted_284 = {
  class: "pdfTopInfo",
  cellspacing: "0"
}
const _hoisted_285 = { class: "pdfTopTr" }
const _hoisted_286 = { class: "pdfTopTdLarge pdfCellBorder" }
const _hoisted_287 = { class: "pdfFont" }
const _hoisted_288 = { class: "pdfTopTdLarge pdfCellBorder" }
const _hoisted_289 = { class: "pdfFont" }
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfTopTdSmall pdfCellBorder" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, [
    /*#__PURE__*/_createElementVNode("strong", null, "Resultat")
  ])
], -1))
const _hoisted_291 = { class: "pdfTopTr" }
const _hoisted_292 = { class: "pdfTopTdLarge pdfCellBorder" }
const _hoisted_293 = { class: "pdfFont" }
const _hoisted_294 = { class: "pdfTopTdLarge pdfCellBorder" }
const _hoisted_295 = { class: "pdfFont" }
const _hoisted_296 = { class: "pdfTopTdSmall pdfCellBorder" }
const _hoisted_297 = { class: "pdfFont" }
const _hoisted_298 = { class: "pdfTopTr" }
const _hoisted_299 = { class: "pdfTopTdLarge pdfCellBorder" }
const _hoisted_300 = { class: "pdfFont" }
const _hoisted_301 = { class: "pdfTopTdLarge pdfCellBorder" }
const _hoisted_302 = { class: "pdfFont" }
const _hoisted_303 = { class: "pdfTopTdSmall pdfCellBorder" }
const _hoisted_304 = { class: "pdfFont" }
const _hoisted_305 = { class: "pdf-item" }
const _hoisted_306 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pdfPlayerHeadline" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Hjemmehold")
], -1))
const _hoisted_307 = {
  class: "pdfPlayerInfo",
  cellspacing: "0"
}
const _hoisted_308 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "pdfPlayerTr" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerLarge pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Navn")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Licens")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Vundne kampe")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Vundne sæt")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Tabte sæt")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "180")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Højeste lukker")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Højeste sæt")
  ])
], -1))
const _hoisted_309 = { class: "pdfPlayerLarge pdfCellBorder" }
const _hoisted_310 = { class: "pdfFont" }
const _hoisted_311 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_312 = {
  key: 0,
  class: "pdfFont center"
}
const _hoisted_313 = {
  key: 1,
  class: "pdfFont center"
}
const _hoisted_314 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_315 = { class: "pdfFont" }
const _hoisted_316 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_317 = { class: "pdfFont" }
const _hoisted_318 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_319 = { class: "pdfFont" }
const _hoisted_320 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_321 = { class: "pdfFont" }
const _hoisted_322 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_323 = { class: "pdfFont" }
const _hoisted_324 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_325 = { class: "pdfFont" }
const _hoisted_326 = { class: "pdf-item" }
const _hoisted_327 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pdfPlayerHeadline" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Udehold")
], -1))
const _hoisted_328 = {
  class: "pdfPlayerInfo",
  cellspacing: "0"
}
const _hoisted_329 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "pdfPlayerTr" }, [
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerLarge pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Navn")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Licens")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Vundne kampe")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Vundne sæt")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Tabte sæt")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "180")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Højeste lukker")
  ]),
  /*#__PURE__*/_createElementVNode("td", { class: "pdfPlayerSmall pdfCellBorder" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Højeste sæt")
  ])
], -1))
const _hoisted_330 = { class: "pdfPlayerLarge pdfCellBorder" }
const _hoisted_331 = { class: "pdfFont" }
const _hoisted_332 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_333 = {
  key: 0,
  class: "pdfFont center"
}
const _hoisted_334 = {
  key: 1,
  class: "pdfFont center"
}
const _hoisted_335 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_336 = { class: "pdfFont" }
const _hoisted_337 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_338 = { class: "pdfFont" }
const _hoisted_339 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_340 = { class: "pdfFont" }
const _hoisted_341 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_342 = { class: "pdfFont" }
const _hoisted_343 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_344 = { class: "pdfFont" }
const _hoisted_345 = { class: "pdfPlayerSmall pdfCellBorder" }
const _hoisted_346 = { class: "pdfFont" }
const _hoisted_347 = {
  key: 0,
  class: "pdfItem"
}
const _hoisted_348 = {
  key: 0,
  class: "pdfMatchInfo mt-5",
  cellspacing: "1"
}
const _hoisted_349 = { class: "pdfMatchHeadTr" }
const _hoisted_350 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Kamp")
], -1))
const _hoisted_351 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchLarge pdfCellBorder" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Navn")
], -1))
const _hoisted_352 = { class: "pdfMatchSmall pdfCellBorder center" }
const _hoisted_353 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Rest")
], -1))
const _hoisted_354 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Dart")
], -1))
const _hoisted_355 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Lukket")
], -1))
const _hoisted_356 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Lukket")
], -1))
const _hoisted_357 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Dart")
], -1))
const _hoisted_358 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Rest")
], -1))
const _hoisted_359 = { class: "pdfMatchSmall pdfCellBorder center" }
const _hoisted_360 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "pdfMatchLarge pdfCellBorder",
  style: {"text-align":"right","padding-right":"2pt"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Navn")
], -1))
const _hoisted_361 = { class: "pdfMatchMedium pdfCellBorder pdfFont" }
const _hoisted_362 = {
  key: 0,
  class: "pdfMatchLarge pdfCellBorder pdfFont"
}
const _hoisted_363 = {
  key: 1,
  class: "pdfMatchLarge pdfCellBorder pdfFont"
}
const _hoisted_364 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_365 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_366 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_367 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchSmall pdfCellBorder" }, null, -1))
const _hoisted_368 = {
  key: 2,
  colspan: "6"
}
const _hoisted_369 = {
  key: 3,
  colspan: "6"
}
const _hoisted_370 = { style: {"width":"100%"} }
const _hoisted_371 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder" }, "​", -1))
const _hoisted_372 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder" }, "​", -1))
const _hoisted_373 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder" }, "​", -1))
const _hoisted_374 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder" }, "​", -1))
const _hoisted_375 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder" }, "​", -1))
const _hoisted_376 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder" }, "​", -1))
const _hoisted_377 = [
  _hoisted_371,
  _hoisted_372,
  _hoisted_373,
  _hoisted_374,
  _hoisted_375,
  _hoisted_376
]
const _hoisted_378 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchSmall pdfCellBorder" }, null, -1))
const _hoisted_379 = {
  key: 4,
  class: "pdfMatchLarge pdfCellBorder pdfFont"
}
const _hoisted_380 = {
  key: 5,
  class: "pdfMatchLarge pdfCellBorder pdfFont"
}
const _hoisted_381 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_382 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_383 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_384 = {
  key: 1,
  class: "pdfMatchInfo mt-5",
  cellspacing: "1"
}
const _hoisted_385 = { class: "pdfMatchHeadTr" }
const _hoisted_386 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Kamp")
], -1))
const _hoisted_387 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchLarge pdfCellBorder" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Navn")
], -1))
const _hoisted_388 = { class: "pdfMatchSmall pdfCellBorder center" }
const _hoisted_389 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Rest")
], -1))
const _hoisted_390 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Dart")
], -1))
const _hoisted_391 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Lukket")
], -1))
const _hoisted_392 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Lukket")
], -1))
const _hoisted_393 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Dart")
], -1))
const _hoisted_394 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchMedium pdfCellBorder center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Rest")
], -1))
const _hoisted_395 = { class: "pdfMatchSmall pdfCellBorder center" }
const _hoisted_396 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "pdfMatchLarge pdfCellBorder",
  style: {"text-align":"right","padding-right":"2pt"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "pdfFont" }, "Navn")
], -1))
const _hoisted_397 = { class: "pdfMatchMedium pdfCellBorder pdfFont" }
const _hoisted_398 = {
  key: 0,
  class: "pdfMatchLarge pdfCellBorder pdfFont"
}
const _hoisted_399 = {
  key: 1,
  class: "pdfMatchLarge pdfCellBorder pdfFont"
}
const _hoisted_400 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_401 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_402 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_403 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchSmall pdfCellBorder" }, null, -1))
const _hoisted_404 = {
  key: 2,
  colspan: "6"
}
const _hoisted_405 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_406 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_407 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_408 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_409 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_410 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "grid-cell" }, null, -1))
const _hoisted_411 = [
  _hoisted_405,
  _hoisted_406,
  _hoisted_407,
  _hoisted_408,
  _hoisted_409,
  _hoisted_410
]
const _hoisted_412 = {
  key: 3,
  colspan: "6"
}
const _hoisted_413 = { class: "grid-cell" }
const _hoisted_414 = { class: "grid-cell" }
const _hoisted_415 = { class: "grid-cell" }
const _hoisted_416 = { class: "grid-cell" }
const _hoisted_417 = { class: "grid-cell" }
const _hoisted_418 = { class: "grid-cell" }
const _hoisted_419 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "pdfMatchSmall pdfCellBorder" }, null, -1))
const _hoisted_420 = {
  key: 4,
  class: "pdfMatchLarge pdfCellBorder pdfFont"
}
const _hoisted_421 = {
  key: 5,
  class: "pdfMatchLarge pdfCellBorder pdfFont"
}
const _hoisted_422 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_423 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_424 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoadingButton = _resolveComponent("LoadingButton")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_radio = _resolveComponent("va-radio")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_VaCheckbox = _resolveComponent("VaCheckbox")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_option_list = _resolveComponent("va-option-list")!
  const _component_TournamentAdvancedMatchSetRoundsMode = _resolveComponent("TournamentAdvancedMatchSetRoundsMode")!
  const _component_va_progress_bar = _resolveComponent("va-progress-bar")!
  const _component_it_modal = _resolveComponent("it-modal")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_divider = _resolveComponent("va-divider")!
  const _component_va_chip = _resolveComponent("va-chip")!
  const _component_vue3_html2pdf = _resolveComponent("vue3-html2pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    (!(_ctx.spectatorMode || _ctx.matchPlayed) && _ctx.match !== undefined && _ctx.match.kampgodkendt_id !== undefined && (_ctx.match.kampgodkendt_id === null || (_ctx.match.kampgodkendt_id !== null && _ctx.match.kampgodkendt_id.kampgodkendt_godkendt === false)))
      ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _hoisted_7))
      : _createCommentVNode("", true),
    _hoisted_8,
    _hoisted_9,
    (_ctx.match !== undefined && _ctx.match.id !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.loadingStatusTestTjekLovligeSpillere)
              ? (_openBlock(), _createBlock(_component_LoadingButton, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  (!_ctx.spectatorMode && !_ctx.isSinglePlayerTournament)
                    ? (_openBlock(), _createBlock(_component_va_button, {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkTeamsLegality(true)))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _createElementVNode("div", _hoisted_14, [
            (!_ctx.spectatorMode && _ctx.logTeamData)
              ? (_openBlock(), _createBlock(_component_va_button, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.checkTeamsData()))
                }, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_va_button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.matchCardPrintoutOptionsModal = true))
            }, {
              default: _withCtx(() => [
                _hoisted_17
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.match !== undefined && _ctx.match.id !== undefined && _ctx.matchExecution.kampafvikling_ekstras_id !== undefined && !(_ctx.matchExecution.kampafvikling_ekstras_id.length > 0) && !_ctx.isSinglePlayerTournament && _ctx.havePermission())
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_va_button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTeam(false)))
            }, {
              default: _withCtx(() => [
                _hoisted_20
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_va_button, {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTeam(true)))
            }, {
              default: _withCtx(() => [
                _hoisted_22
              ]),
              _: 1
            })
          ])
        ]))
      : (!(_ctx.spectatorMode || _ctx.matchPlayed) && _ctx.match !== undefined && _ctx.match.id !== undefined && _ctx.matchExecution.kampafvikling_ekstras_id !== undefined && (_ctx.matchExecution.kampafvikling_ekstras_id.length > 0) && _ctx.havePermission())
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_va_button, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.matchTeamResetWarningModal=true))
              }, {
                default: _withCtx(() => [
                  _hoisted_25
                ]),
                _: 1
              })
            ])
          ]))
        : _createCommentVNode("", true),
    (_ctx.match !== undefined && _ctx.match.id !== undefined && !_ctx.isSinglePlayerTournament && _ctx.havePermission())
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _withDirectives(_createElementVNode("div", _hoisted_27, [
            _createElementVNode("h6", {
              class: "center display-6 clickAble",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setTeam(false)))
            }, "Hjemmeholdet"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homeTeamArray, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: index
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", null, _toDisplayString((index +1).toString() + '. ' + item.name), 1)
                ])
              ]))
            }), 128))
          ], 512), [
            [_vShow, !_ctx.finishedSettingHomeTeam]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_29, [
            _createElementVNode("h6", {
              class: "center display-6 clickAble",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setTeam(true)))
            }, "Udeholdet"),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.awayTeamArray, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row",
                key: index
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("p", null, _toDisplayString(String.fromCharCode(index +65).toString() + '. ' + item.name), 1)
                ])
              ]))
            }), 128))
          ], 512), [
            [_vShow, _ctx.match !== undefined && _ctx.match.id !== undefined && !_ctx.finishedSettingAwayTeam]
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.match !== undefined && _ctx.match.id !== undefined && _ctx.matchExecution.kampafvikling_ekstras_id !== undefined && !(_ctx.matchExecution.kampafvikling_ekstras_id.length > 0) && !_ctx.isSinglePlayerTournament)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_va_button, {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.teamCaptainSelectionModel = true))
            }, {
              default: _withCtx(() => [
                _hoisted_33
              ]),
              _: 1
            })
          ])
        ], 512)), [
          [_vShow, _ctx.homeTeamArray.length >= _ctx.matchRules.minPlayers && _ctx.awayTeamArray.length >= _ctx.matchRules.minPlayers && _ctx.havePermission()]
        ])
      : _createCommentVNode("", true),
    (_ctx.match !== undefined && _ctx.match.id !== undefined && _ctx.matchExecution.kampafvikling_ekstras_id !== undefined && !(_ctx.matchExecution.kampafvikling_ekstras_id.length > 0) && !_ctx.isSinglePlayerTournament)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            (_ctx.loadingStatusBegyndKampen)
              ? (_openBlock(), _createBlock(_component_LoadingButton, {
                  key: 0,
                  color: "success"
                }))
              : (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  color: "success",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.checkTeamsLegality())),
                  disabled: !_ctx.setupMatchSettlementTeamPlayersExtDataCompletede || _ctx.match?.homeTeamCaptain === null || _ctx.match?.awayTeamCaptain === null
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 1
                }, 8, ["disabled"]))
          ])
        ], 512)), [
          [_vShow, _ctx.homeTeamArray.length >= _ctx.matchRules.minPlayers && _ctx.awayTeamArray.length >= _ctx.matchRules.minPlayers && _ctx.havePermission()]
        ])
      : _createCommentVNode("", true),
    (_ctx.isSinglePlayerTournament && !(_ctx.matchExecution?.kampafvikling_ekstras_id?.length > 0) && _ctx.havePermission())
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            (_ctx.loadingStatusBegyndkamp)
              ? (_openBlock(), _createBlock(_component_LoadingButton, {
                  key: 0,
                  color: "success"
                }))
              : (_openBlock(), _createBlock(_component_va_button, {
                  key: 1,
                  color: "success",
                  onClick: _ctx.reMapPlayers
                }, {
                  default: _withCtx(() => [
                    _hoisted_39
                  ]),
                  _: 1
                }, 8, ["onClick"]))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.match !== undefined && _ctx.match.id !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
          _createElementVNode("table", _hoisted_41, [
            _createElementVNode("thead", null, [
              _hoisted_42,
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _hoisted_43,
                  _createElementVNode("b", null, _toDisplayString(_ctx.match.kampprogram_kampnr), 1),
                  _hoisted_44,
                  _createElementVNode("b", null, _toDisplayString((_ctx.match.kampprogram_kamprunde === undefined || _ctx.match.kampprogram_kamprunde === null ? '-' : _ctx.match.kampprogram_kamprunde.toString())), 1)
                ]),
                _createElementVNode("td", null, [
                  _hoisted_45,
                  _createElementVNode("b", null, _toDisplayString(_ctx.match.raekke_id.raekke_navn), 1)
                ]),
                _createElementVNode("td", null, [
                  (!_ctx.spectatorMode && !_ctx.matchPlayed)
                    ? (_openBlock(), _createBlock(_component_va_button, {
                        key: 0,
                        color: "success",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.finishMatchCheckupValuesOfFields())),
                        disabled: _ctx.updateTournamentMatchProcessFlag
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _hoisted_47,
                  _createElementVNode("b", null, _toDisplayString(_ctx.getDanishDate(_ctx.match.kampprogram_dato)), 1)
                ]),
                _createElementVNode("td", null, [
                  _hoisted_48,
                  _createElementVNode("b", null, _toDisplayString(_ctx.match.kampprogram_hjemmehold.hold_holdnavn), 1)
                ]),
                _createElementVNode("td", _hoisted_49, [
                  _hoisted_50,
                  _createElementVNode("b", null, _toDisplayString(_ctx.matchPlayed ? (_ctx.matchExecution.kampafvikling_resultat_hjem === null ? 0 : _ctx.matchExecution.kampafvikling_resultat_hjem) : _ctx.cachedTotalResultHome), 1)
                ])
              ]),
              _createElementVNode("tr", null, [
                _createElementVNode("td", null, [
                  _hoisted_51,
                  _createElementVNode("b", null, "kl. " + _toDisplayString(_ctx.getTime(_ctx.match.kampprogram_dato)), 1)
                ]),
                _createElementVNode("td", null, [
                  _hoisted_52,
                  _createElementVNode("b", null, _toDisplayString(_ctx.match.kampprogram_udehold.hold_holdnavn), 1)
                ]),
                _createElementVNode("td", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("b", null, _toDisplayString(_ctx.matchPlayed ? (_ctx.matchExecution.kampafvikling_resultat_ude === null ? 0 : _ctx.matchExecution.kampafvikling_resultat_ude) : _ctx.cachedTotalResultGuest), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_55,
    (!_ctx.spectatorMode && !_ctx.matchPlayed)
      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.protestOptionsList, (option, index) => {
            return (_openBlock(), _createBlock(_component_va_radio, {
              class: "matchCardProtestOptions",
              modelValue: _ctx.protestValue,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.protestValue) = $event)),
              option: option,
              key: index
            }, null, 8, ["modelValue", "option"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.match !== undefined && _ctx.match.id !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
          _createElementVNode("table", _hoisted_58, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.match.kampprogram_hjemmehold.hold_holdnavn), 1)
              ]),
              _hoisted_60
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.homePlayersInfoData.filter(el => !el.hide), (homeTeam, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(index +1 + '. ' + homeTeam.name), 1),
                  _createElementVNode("td", _hoisted_61, _toDisplayString(homeTeam?.totalPlayerHomeSnit?.toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_62, _toDisplayString(homeTeam.license), 1),
                  _createElementVNode("td", _hoisted_63, _toDisplayString(homeTeam.matchesWon), 1),
                  _createElementVNode("td", _hoisted_64, _toDisplayString(homeTeam.matchSetsWon), 1),
                  _createElementVNode("td", _hoisted_65, _toDisplayString(homeTeam.matchSetsLost), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_va_input, {
                      class: "matchInput",
                      type: "number",
                      inputmode: "numeric",
                      step: "1",
                      pattern: "^[-\\d]\\d*$",
                      modelValue: homeTeam.match180,
                      "onUpdate:modelValue": ($event: any) => ((homeTeam.match180) = $event),
                      modelModifiers: { trim: true, number: true },
                      error: (homeTeam !== undefined && homeTeam.match180 !== undefined && (homeTeam.match180.toString().length === 0 || homeTeam.match180 < 0 || homeTeam.match180 > (_ctx.numberOfMatches * _ctx.numberOfSets * 2))),
                      "error-messages": "Værdien er ugyldigt",
                      onKeypress: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isNumber($event))),
                      onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateMatchResults())),
                      onKeyup: _cache[14] || (_cache[14] = _withKeys(($event: any) => (_ctx.updateMatchResults()), ["enter"])),
                      onFocus: _cache[15] || (_cache[15] = ($event: any) => ($event.target.select())),
                      readonly: _ctx.spectatorMode || _ctx.matchPlayed || !homeTeam.match180WriteOnlyMode,
                      bordered: "",
                      style: {"padding-top":"0px","--va-form-element-default-width":"100px","--va-input-content-horizontal-padding":"2"}
                    }, {
                      appendInner: _withCtx(() => [
                        _createVNode(_component_va_icon, {
                          name: (homeTeam.match180WriteOnlyMode ? 'lock_open' : 'lock'),
                          onClick: ($event: any) => (homeTeam.match180WriteOnlyMode = !homeTeam.match180WriteOnlyMode, _ctx.match180WriteOnlyModeTriggerFlag = homeTeam.match180WriteOnlyMode)
                        }, null, 8, ["name", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "error", "readonly"])
                  ]),
                  _createElementVNode("td", _hoisted_66, _toDisplayString(homeTeam.matchSetHighestClosing), 1),
                  _createElementVNode("td", _hoisted_67, _toDisplayString(homeTeam.matchSetFastestDarting), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_68,
    (_ctx.match !== undefined && _ctx.match.id !== undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
          _createElementVNode("table", _hoisted_70, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", _hoisted_71, _toDisplayString(_ctx.match.kampprogram_udehold.hold_holdnavn), 1)
              ]),
              _hoisted_72
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.awayPlayersInfoData.filter(el => !el.hide), (awayTeam, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, _toDisplayString(String.fromCharCode(index + 65) + '. ' + awayTeam.name), 1),
                  _createElementVNode("td", _hoisted_73, _toDisplayString(awayTeam?.totalAwayPlayerSnit?.toFixed(2)), 1),
                  _createElementVNode("td", _hoisted_74, _toDisplayString(awayTeam.license), 1),
                  _createElementVNode("td", _hoisted_75, _toDisplayString(awayTeam.matchesWon), 1),
                  _createElementVNode("td", _hoisted_76, _toDisplayString(awayTeam.matchSetsWon), 1),
                  _createElementVNode("td", _hoisted_77, _toDisplayString(awayTeam.matchSetsLost), 1),
                  _createElementVNode("td", null, [
                    _createVNode(_component_va_input, {
                      class: "matchInput",
                      type: "number",
                      inputmode: "numeric",
                      step: "1",
                      pattern: "^[-\\d]\\d*$",
                      modelValue: awayTeam.match180,
                      "onUpdate:modelValue": ($event: any) => ((awayTeam.match180) = $event),
                      modelModifiers: { trim: true, number: true },
                      error: (awayTeam !== undefined && awayTeam.match180 !== undefined && (awayTeam.match180.toString().length === 0 || awayTeam.match180 < 0 || awayTeam.match180 > (_ctx.numberOfMatches * _ctx.numberOfSets * 2))),
                      "error-messages": "Værdien er ugyldigt",
                      onKeypress: _cache[16] || (_cache[16] = ($event: any) => (_ctx.isNumber($event))),
                      onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateMatchResults())),
                      onKeyup: _cache[18] || (_cache[18] = _withKeys(($event: any) => (_ctx.updateMatchResults()), ["enter"])),
                      onFocus: _cache[19] || (_cache[19] = ($event: any) => ($event.target.select())),
                      readonly: _ctx.spectatorMode || _ctx.matchPlayed || !awayTeam.match180WriteOnlyMode,
                      bordered: "",
                      style: {"padding-top":"0px","--va-form-element-default-width":"100px","--va-input-content-horizontal-padding":"2"}
                    }, {
                      appendInner: _withCtx(() => [
                        _createVNode(_component_va_icon, {
                          name: (awayTeam.match180WriteOnlyMode ? 'lock_open' : 'lock'),
                          onClick: ($event: any) => (awayTeam.match180WriteOnlyMode = !awayTeam.match180WriteOnlyMode, _ctx.match180WriteOnlyModeTriggerFlag = awayTeam.match180WriteOnlyMode)
                        }, null, 8, ["name", "onClick"])
                      ]),
                      _: 2
                    }, 1032, ["modelValue", "onUpdate:modelValue", "error", "readonly"])
                  ]),
                  _createElementVNode("td", _hoisted_78, _toDisplayString(awayTeam.matchSetHighestClosing), 1),
                  _createElementVNode("td", _hoisted_79, _toDisplayString(awayTeam.matchSetFastestDarting), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_80,
    ((_ctx.matchesCreated === _ctx.numberOfMatches && _ctx.setsCreated === (_ctx.numberOfSets * _ctx.numberOfMatches)) || _ctx.forceShowMatchCardTable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
          _createElementVNode("table", _hoisted_82, [
            _hoisted_83,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMatchData(), (row, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  _createElementVNode("tr", _hoisted_84, [
                    _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                    (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer2 === undefined || row.matchHomeTeamPlayer2 === null)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_85, "-"))
                      : (_openBlock(), _createElementBlock("td", _hoisted_86, [
                          _createElementVNode("span", {
                            onClick: ($event: any) => (_ctx.clickShowChangesTeamMatchStatusModal(index, row.matchRealIndexNumber, true))
                          }, [
                            _createTextVNode(_toDisplayString((row.matchHomeTeamPlayer === '9' ? '' : row.matchHomeTeamPlayer + ' ' + row.matchHomeTeamPlayerName)), 1),
                            _hoisted_88,
                            _createTextVNode(_toDisplayString((row.matchHomeTeamPlayer2 === '9' ? '' : row.matchHomeTeamPlayer2 + ' ' + row.matchHomeTeamPlayer2Name)), 1),
                            _hoisted_89,
                            _createTextVNode(_toDisplayString((row.matchHomeScoreResultRecorder === null ? '' : (row.matchHomeScoreResultRecorder === '0' ? '* Udlæg & tavlefører' : '* (' + row.matchHomeScoreResultRecorder + ')'))), 1)
                          ], 8, _hoisted_87)
                        ])),
                    (_ctx.setsCreated !== _ctx.numberOfSets * _ctx.numberOfMatches)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _createElementVNode("table", _hoisted_92, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_93,
                                  _hoisted_94,
                                  _hoisted_95,
                                  _hoisted_96,
                                  _createElementVNode("th", _hoisted_97, [
                                    _createElementVNode("span", _hoisted_98, [
                                      _createVNode(_component_va_popover, {
                                        class: "mr-2",
                                        placement: "top",
                                        message: "Startede først"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_99
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfSets, (nbr) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: nbr }, [
                                    _hoisted_100,
                                    _hoisted_101,
                                    _hoisted_102,
                                    _createElementVNode("td", _hoisted_103, [
                                      _createVNode(_component_va_checkbox, {
                                        class: "mb-6",
                                        readonly: true
                                      })
                                    ])
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_104, [
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("table", _hoisted_106, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _hoisted_107,
                                  _hoisted_108,
                                  _hoisted_109,
                                  _hoisted_110,
                                  _createElementVNode("th", _hoisted_111, [
                                    _createElementVNode("span", _hoisted_112, [
                                      _createVNode(_component_va_popover, {
                                        class: "mr-2",
                                        placement: "top",
                                        message: "Startede først"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_113
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSetResultsData((index + 1)), (setRow) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: setRow.matchSet
                                  }, [
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_114, _toDisplayString(setRow.matchAverageScore), 1))
                                      : _createCommentVNode("", true),
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_115, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "matchInput",
                                            type: "number",
                                            inputmode: "numeric",
                                            step: "1",
                                            pattern: "^[-\\d]\\d*$",
                                            "onUpdate:modelValue": ($event: any) => ((setRow.matchSetRemainScore) = $event),
                                            onKeypress: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isNumber($event))),
                                            onChange: ($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))),
                                            onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))), ["enter"]),
                                            onFocus: _cache[21] || (_cache[21] = ($event: any) => ($event.target.select())),
                                            error: (setRow.matchSetDirtyFlag & 8) === 8,
                                            "error-message": "Værdien er ugyldigt",
                                            disabled: (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer === '9' || (row.matchIsDouble && (row.matchHomeTeamPlayer2 === undefined || row.matchHomeTeamPlayer2 === null || row.matchHomeTeamPlayer2 === '9')) || (!row.matchIsDouble && (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer === 'Z'))),
                                            readonly: _ctx.spectatorMode || _ctx.matchPlayed
                                          }, null, 40, _hoisted_116), [
                                            [
                                              _vModelText,
                                              setRow.matchSetRemainScore,
                                              void 0,
                                              {
                                                trim: true,
                                                number: true
                                              }
                                            ]
                                          ]),
                                          ((setRow.matchSetDirtyFlag & 4) === 4)
                                            ? (_openBlock(), _createBlock(_component_va_icon, {
                                                key: 0,
                                                name: "loop",
                                                spin: "counter-clockwise",
                                                color: ((setRow.matchSetDirtyFlag & 8) === 8 ? '#af0000' : '#00af00')
                                              }, null, 8, ["color"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_117, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "matchInput",
                                            type: "number",
                                            inputmode: "numeric",
                                            step: "1",
                                            pattern: "^[-\\d]\\d*$",
                                            "onUpdate:modelValue": ($event: any) => ((setRow.matchSetDart) = $event),
                                            onKeypress: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isNumber($event))),
                                            onChange: ($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))),
                                            onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))), ["enter"]),
                                            onFocus: _cache[23] || (_cache[23] = ($event: any) => ($event.target.select())),
                                            error: (setRow.matchSetDirtyFlag & 1) === 1,
                                            "error-message": "Værdien er ugyldigt",
                                            disabled: (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer === '9' || (row.matchIsDouble && (row.matchHomeTeamPlayer2 === undefined || row.matchHomeTeamPlayer2 === null || row.matchHomeTeamPlayer2 === '9')) || (!row.matchIsDouble && (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer === 'Z'))),
                                            readonly: _ctx.spectatorMode || _ctx.matchPlayed
                                          }, null, 40, _hoisted_118), [
                                            [
                                              _vModelText,
                                              setRow.matchSetDart,
                                              void 0,
                                              {
                                                trim: true,
                                                number: true
                                              }
                                            ]
                                          ]),
                                          ((setRow.matchSetDirtyFlag & 4) === 4)
                                            ? (_openBlock(), _createBlock(_component_va_icon, {
                                                key: 0,
                                                name: "loop",
                                                spin: "counter-clockwise",
                                                color: ((setRow.matchSetDirtyFlag & 1) === 1 ? '#af0000' : '#00af00')
                                              }, null, 8, ["color"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_119, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "matchInput",
                                            type: "number",
                                            inputmode: "numeric",
                                            step: "1",
                                            pattern: "^[-\\d]\\d*$",
                                            "onUpdate:modelValue": ($event: any) => ((setRow.matchSetClosed) = $event),
                                            onKeypress: _cache[24] || (_cache[24] = ($event: any) => (_ctx.isNumber($event))),
                                            onChange: ($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))),
                                            onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))), ["enter"]),
                                            onFocus: _cache[25] || (_cache[25] = ($event: any) => ($event.target.select())),
                                            error: (setRow.matchSetDirtyFlag & 2) === 2,
                                            "error-message": "Værdien er ugyldigt",
                                            disabled: (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer === '9' || (row.matchIsDouble && (row.matchHomeTeamPlayer2 === undefined || row.matchHomeTeamPlayer2 === null || row.matchHomeTeamPlayer2 === '9')) || (!row.matchIsDouble && (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer === 'Z'))),
                                            readonly: _ctx.spectatorMode || _ctx.matchPlayed
                                          }, null, 40, _hoisted_120), [
                                            [
                                              _vModelText,
                                              setRow.matchSetClosed,
                                              void 0,
                                              {
                                                trim: true,
                                                number: true
                                              }
                                            ]
                                          ]),
                                          ((setRow.matchSetDirtyFlag & 4) === 4)
                                            ? (_openBlock(), _createBlock(_component_va_icon, {
                                                key: 0,
                                                name: "loop",
                                                spin: "counter-clockwise",
                                                color: ((setRow.matchSetDirtyFlag & 2) === 2 ? '#af0000' : '#00af00')
                                              }, null, 8, ["color"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_121, [
                                          _createVNode(_component_va_checkbox, {
                                            class: "mb-6",
                                            modelValue: setRow.matchPlayerWhoStartedFirstRound,
                                            "onUpdate:modelValue": ($event: any) => ((setRow.matchPlayerWhoStartedFirstRound) = $event),
                                            indeterminate: "",
                                            readonly: _ctx.spectatorMode || _ctx.matchPlayed,
                                            onClick: ($event: any) => (_ctx.conditionalUpdateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore))))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])),
                    _createElementVNode("td", null, [
                      (!_ctx.spectatorMode && (_ctx.match.kampgodkendt_id === null || (_ctx.match.kampgodkendt_id !== null && _ctx.match.kampgodkendt_id.kampgodkendt_godkendt === false)))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_122, [
                            _createElementVNode("table", _hoisted_123, [
                              _hoisted_124,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSetResultsData((index + 1)), (setRow) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: setRow.matchSet
                                  }, [
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam && setRow.matchSet === 0)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_125, [
                                          _createVNode(_component_va_button, {
                                            color: "primary",
                                            onClick: ($event: any) => (_ctx.activateAdvancedMatchSetRoundsMode(false, (row.matchGuestScoreResultRecorder === null ? (row.matchHomeScoreResultRecorder === null ? _ctx.toggleSubmatchFlipFlopFlag() : true) : false), setRow.matchIndexNumber, setRow.matchSet, Number(_ctx.match.id), (_ctx.match.raekke_id !== undefined && _ctx.match.raekke_id.raekke_antalsaet !== null ? _ctx.match.raekke_id.raekke_antalsaet : 3), row.matchHomeTeamPlayer, row.matchHomeTeamPlayer2, row.matchGuestTeamPlayer, row.matchGuestTeamPlayer2, row.matchIsDouble, [(_ctx.match.kampprogram_udehold.hold_holdnavn !== null ? _ctx.match.kampprogram_udehold.hold_holdnavn : ''), (_ctx.match.kampprogram_hjemmehold.hold_holdnavn !== null ? _ctx.match.kampprogram_hjemmehold.hold_holdnavn : '')], [row.matchGuestTeamPlayerName, row.matchHomeTeamPlayerName], [row.matchGuestTeamPlayer2Name, row.matchHomeTeamPlayer2Name], setRow.matchId, _ctx.match.raekke_id.turneringskategori_id))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_126
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSetResultsData((index + 1)), (setRow) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: setRow.matchSet
                                  }, [
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam && setRow.matchSet === 0 && _ctx.checkForCompletedMatch(index + 1))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_127, [
                                          _createVNode(_component_va_button, {
                                            color: "primary",
                                            onClick: ($event: any) => (_ctx.showTheScore(setRow.matchId))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_128
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_129, [
                            _createElementVNode("table", _hoisted_130, [
                              _hoisted_131,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSetResultsData((index + 1)), (setRow) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: setRow.matchSet
                                  }, [
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam && setRow.matchSet === 0 && _ctx.checkForLiveMatch(setRow.matchId))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_132, [
                                          _createVNode(_component_va_button, {
                                            color: "primary",
                                            onClick: ($event: any) => (_ctx.showLiveMatchPage(setRow.matchId))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_133
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSetResultsData((index + 1)), (setRow) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: setRow.matchSet
                                  }, [
                                    (setRow.matchIndexNumber === (index + 1) && setRow.matchHomeOrAwayTeam && setRow.matchSet === 0 && _ctx.checkForCompletedMatch(index + 1))
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_134, [
                                          _createVNode(_component_va_button, {
                                            color: "primary",
                                            onClick: ($event: any) => (_ctx.showTheScore(setRow.matchId))
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_135
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ]))
                    ]),
                    (_ctx.setsCreated !== _ctx.numberOfSets * _ctx.numberOfMatches)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_136, [
                          _createElementVNode("div", _hoisted_137, [
                            _createElementVNode("table", _hoisted_138, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_139, [
                                    _createElementVNode("span", _hoisted_140, [
                                      _createVNode(_component_va_popover, {
                                        class: "mr-2",
                                        placement: "top",
                                        message: "Startede først"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_141
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _hoisted_142,
                                  _hoisted_143,
                                  _hoisted_144,
                                  _hoisted_145
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfSets, (nbr) => {
                                  return (_openBlock(), _createElementBlock("tr", { key: nbr }, [
                                    _createElementVNode("td", _hoisted_146, [
                                      _createVNode(_component_va_checkbox, {
                                        class: "mb-6",
                                        readonly: true
                                      })
                                    ]),
                                    _hoisted_147,
                                    _hoisted_148,
                                    _hoisted_149
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("td", _hoisted_150, [
                          _createElementVNode("div", _hoisted_151, [
                            _createElementVNode("table", _hoisted_152, [
                              _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                  _createElementVNode("th", _hoisted_153, [
                                    _createElementVNode("span", _hoisted_154, [
                                      _createVNode(_component_va_popover, {
                                        class: "mr-2",
                                        placement: "top",
                                        message: "Startede først"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_155
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]),
                                  _hoisted_156,
                                  _hoisted_157,
                                  _hoisted_158,
                                  _hoisted_159
                                ])
                              ]),
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSetResultsData((index + 1)), (setRow) => {
                                  return (_openBlock(), _createElementBlock("tr", {
                                    key: setRow.matchSet
                                  }, [
                                    (setRow.matchIndexNumber === (index + 1) && !setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_160, [
                                          _createVNode(_component_va_checkbox, {
                                            class: "mb-6",
                                            modelValue: setRow.matchPlayerWhoStartedFirstRound,
                                            "onUpdate:modelValue": ($event: any) => ((setRow.matchPlayerWhoStartedFirstRound) = $event),
                                            "true-value": false,
                                            "false-value": true,
                                            indeterminate: "",
                                            readonly: _ctx.spectatorMode || _ctx.matchPlayed,
                                            onClick: ($event: any) => (_ctx.conditionalUpdateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore))))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "onClick"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    (setRow.matchIndexNumber === (index + 1) && !setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_161, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "matchInput",
                                            type: "number",
                                            inputmode: "numeric",
                                            step: "1",
                                            pattern: "^[-\\d]\\d*$",
                                            "onUpdate:modelValue": ($event: any) => ((setRow.matchSetClosed) = $event),
                                            onKeypress: _cache[26] || (_cache[26] = ($event: any) => (_ctx.isNumber($event))),
                                            onChange: ($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))),
                                            onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))), ["enter"]),
                                            onFocus: _cache[27] || (_cache[27] = ($event: any) => ($event.target.select())),
                                            error: (setRow.matchSetDirtyFlag & 2) === 2,
                                            "error-message": "Værdien er ugyldigt",
                                            disabled: (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer === 'Z' || (row.matchIsDouble && (row.matchGuestTeamPlayer2 === undefined || row.matchGuestTeamPlayer2 === null || row.matchGuestTeamPlayer2 === 'Z')) || (!row.matchIsDouble && (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer === '9'))),
                                            readonly: _ctx.spectatorMode || _ctx.matchPlayed
                                          }, null, 40, _hoisted_162), [
                                            [
                                              _vModelText,
                                              setRow.matchSetClosed,
                                              void 0,
                                              {
                                                trim: true,
                                                number: true
                                              }
                                            ]
                                          ]),
                                          ((setRow.matchSetDirtyFlag & 4) === 4)
                                            ? (_openBlock(), _createBlock(_component_va_icon, {
                                                key: 0,
                                                name: "loop",
                                                spin: "counter-clockwise",
                                                color: ((setRow.matchSetDirtyFlag & 2) === 2 ? '#af0000' : '#00af00')
                                              }, null, 8, ["color"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (setRow.matchIndexNumber === (index + 1) && !setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_163, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "matchInput",
                                            type: "number",
                                            inputmode: "numeric",
                                            step: "1",
                                            pattern: "^[-\\d]\\d*$",
                                            "onUpdate:modelValue": ($event: any) => ((setRow.matchSetDart) = $event),
                                            onKeypress: _cache[28] || (_cache[28] = ($event: any) => (_ctx.isNumber($event))),
                                            onChange: ($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))),
                                            onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))), ["enter"]),
                                            onFocus: _cache[29] || (_cache[29] = ($event: any) => ($event.target.select())),
                                            error: (setRow.matchSetDirtyFlag & 1) === 1,
                                            "error-message": "Værdien er ugyldigt",
                                            disabled: (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer === 'Z' || (row.matchIsDouble && (row.matchGuestTeamPlayer2 === undefined || row.matchGuestTeamPlayer2 === null || row.matchGuestTeamPlayer2 === 'Z')) || (!row.matchIsDouble && (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer === '9'))),
                                            readonly: _ctx.spectatorMode || _ctx.matchPlayed
                                          }, null, 40, _hoisted_164), [
                                            [
                                              _vModelText,
                                              setRow.matchSetDart,
                                              void 0,
                                              {
                                                trim: true,
                                                number: true
                                              }
                                            ]
                                          ]),
                                          ((setRow.matchSetDirtyFlag & 4) === 4)
                                            ? (_openBlock(), _createBlock(_component_va_icon, {
                                                key: 0,
                                                name: "loop",
                                                spin: "counter-clockwise",
                                                color: ((setRow.matchSetDirtyFlag & 1) === 1 ? '#af0000' : '#00af00')
                                              }, null, 8, ["color"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (setRow.matchIndexNumber === (index + 1) && !setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_165, [
                                          _withDirectives(_createElementVNode("input", {
                                            class: "matchInput",
                                            type: "number",
                                            inputmode: "numeric",
                                            step: "1",
                                            pattern: "^[-\\d]\\d*$",
                                            "onUpdate:modelValue": ($event: any) => ((setRow.matchSetRemainScore) = $event),
                                            onKeypress: _cache[30] || (_cache[30] = ($event: any) => (_ctx.isNumber($event))),
                                            onChange: ($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))),
                                            onKeyup: _withKeys(($event: any) => (_ctx.updateDirtyFieldSetResults(setRow.matchIndexNumber, setRow.matchSet, setRow.matchHomeOrAwayTeam, true, Math.round(Number(setRow.matchSetDart)), Math.round(Number(setRow.matchSetClosed)), Math.round(Number(setRow.matchSetRemainScore)))), ["enter"]),
                                            onFocus: _cache[31] || (_cache[31] = ($event: any) => ($event.target.select())),
                                            error: (setRow.matchSetDirtyFlag & 8) === 8,
                                            "error-message": "Værdien er ugyldigt",
                                            disabled: (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer === '9' || (row.matchIsDouble && (row.matchHomeTeamPlayer2 === undefined || row.matchHomeTeamPlayer2 === null || row.matchHomeTeamPlayer2 === '9')) || (!row.matchIsDouble && (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer === 'Z'))),
                                            readonly: _ctx.spectatorMode || _ctx.matchPlayed
                                          }, null, 40, _hoisted_166), [
                                            [
                                              _vModelText,
                                              setRow.matchSetRemainScore,
                                              void 0,
                                              {
                                                trim: true,
                                                number: true
                                              }
                                            ]
                                          ]),
                                          ((setRow.matchSetDirtyFlag & 4) === 4)
                                            ? (_openBlock(), _createBlock(_component_va_icon, {
                                                key: 0,
                                                name: "loop",
                                                spin: "counter-clockwise",
                                                color: ((setRow.matchSetDirtyFlag & 8) === 8 ? '#af0000' : '#00af00')
                                              }, null, 8, ["color"]))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true),
                                    (setRow.matchIndexNumber === (index + 1) && !setRow.matchHomeOrAwayTeam)
                                      ? (_openBlock(), _createElementBlock("td", _hoisted_167, _toDisplayString(setRow.matchAverageScore), 1))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                              ])
                            ])
                          ])
                        ])),
                    (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer2 === undefined || row.matchGuestTeamPlayer2 === null)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_168, "-"))
                      : (_openBlock(), _createElementBlock("td", _hoisted_169, [
                          _createElementVNode("span", {
                            onClick: ($event: any) => (_ctx.clickShowChangesTeamMatchStatusModal(index, row.matchRealIndexNumber, false))
                          }, [
                            _createTextVNode(_toDisplayString((row.matchGuestTeamPlayer === 'Z' ? '' : row.matchGuestTeamPlayer + ' ' + row.matchGuestTeamPlayerName)), 1),
                            _hoisted_171,
                            _createTextVNode(_toDisplayString((row.matchGuestTeamPlayer2 === 'Z' ? '' : row.matchGuestTeamPlayer2 + ' ' + row.matchGuestTeamPlayer2Name)), 1),
                            _hoisted_172,
                            _createTextVNode(_toDisplayString((row.matchGuestScoreResultRecorder === null ? '' : (row.matchGuestScoreResultRecorder === '0' ? '* Udlæg & tavlefører' : '* (' + row.matchGuestScoreResultRecorder + ')'))), 1)
                          ], 8, _hoisted_170)
                        ]))
                  ]),
                  _createElementVNode("tr", _hoisted_173, [
                    _hoisted_174,
                    _createElementVNode("td", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.getHomeTeamMatchData(index + 1)?.homeTeamScore), 1)
                    ]),
                    _hoisted_175,
                    _hoisted_176,
                    _hoisted_177,
                    _createElementVNode("td", null, [
                      _createElementVNode("b", null, _toDisplayString(_ctx.getAwayTeamMatchData(index + 1)?.awayTeamScore), 1)
                    ]),
                    _hoisted_178
                  ])
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.showChangesTeamMatchStatusModal,
      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.showChangesTeamMatchStatusModal) = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      size: "small",
      "no-dismiss": ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("h6", _hoisted_179, "Ændre " + _toDisplayString(_ctx.checkboxMatchPlayerIllnessValue.isHomeTeam ? 'hjemme' : 'ude') + "holdets kamp-status for kamp-nr. " + _toDisplayString((_ctx.checkboxMatchPlayerIllnessValue.matchListIndex + 1)), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_180, [
          _createElementVNode("div", _hoisted_181, [
            _createElementVNode("div", _hoisted_182, [
              _createVNode(_component_VaCheckbox, {
                modelValue: _ctx.checkboxMatchPlayerIllnessValue.value,
                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.checkboxMatchPlayerIllnessValue.value) = $event)),
                class: "mb-6",
                label: "Blev syg"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _hoisted_183
        ])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_184, [
          _createElementVNode("div", _hoisted_185, [
            _createVNode(_component_va_button, {
              class: "btn mr-2",
              color: "success",
              onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.changeTeamMatchStatus()))
            }, {
              default: _withCtx(() => [
                _hoisted_186
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn ml-2",
              color: "secondary",
              onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.showChangesTeamMatchStatusModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_187
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.matchCardPrintoutOptionsModal,
      "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.matchCardPrintoutOptionsModal) = $event)),
      size: "large",
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      "no-dismiss": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_194, [
          _createElementVNode("div", _hoisted_195, [
            _createVNode(_component_va_button, {
              class: "btn mr-2",
              color: "success",
              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.downloadPdf()))
            }, {
              default: _withCtx(() => [
                _hoisted_196
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn ml-2",
              color: "secondary",
              onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.matchCardPrintoutOptionsModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_197
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_188,
        _createElementVNode("div", _hoisted_189, [
          _createElementVNode("div", _hoisted_190, [
            _createElementVNode("div", _hoisted_191, [
              _hoisted_192,
              _hoisted_193,
              _createVNode(_component_va_option_list, {
                type: "radio",
                options: _ctx.matchCardPrintoutOptions,
                modelValue: _ctx.matchCardPrintoutValue,
                "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.matchCardPrintoutValue) = $event)),
                "value-by": "value"
              }, null, 8, ["options", "modelValue"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      fullscreen: "",
      modelValue: _ctx.advancedMatchSetModeModal,
      "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.advancedMatchSetModeModal) = $event)),
      mobileFullscreen: "",
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      "no-dismiss": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_TournamentAdvancedMatchSetRoundsMode, {
          msg: "Kamptavle",
          readOnlyFlag: _ctx.advancedMatchSetRoundsModeData.readOnlyFlag,
          playerToStartFirstRound: _ctx.advancedMatchSetRoundsModeData.startingPlayer,
          submatchWinAtNumberOfWonSets: _ctx.advancedMatchSetRoundsModeData.submatchWinAtNumberOfWonSets,
          matchIndexNumber: _ctx.advancedMatchSetRoundsModeData.matchIndexNumber,
          matchSet: _ctx.advancedMatchSetRoundsModeData.matchSet,
          matchId: _ctx.advancedMatchSetRoundsModeData.matchId,
          playerTeamNames: (_ctx.advancedMatchSetRoundsModeData.matchTeamNames),
          matchTeamPlayersNames: (_ctx.advancedMatchSetRoundsModeData.matchTeamPlayersNames),
          matchTeamSecondPlayersNames: (_ctx.advancedMatchSetRoundsModeData.matchTeamSecondPlayersNames),
          matchIsDouble: (_ctx.advancedMatchSetRoundsModeData.matchIsDouble),
          selectedMatchId: _ctx.advancedMatchSetRoundsModeData.selectedMatchId,
          homeTeamResult: _ctx.advancedMatchSetRoundsModeData.homeTeamResult,
          awayTeamResult: _ctx.advancedMatchSetRoundsModeData.awayTeamResult,
          tournamentCategoryId: _ctx.advancedMatchSetRoundsModeData.tournamentCategoryId,
          onAdvMatchSetRoundsModeStateChanged: _cache[40] || (_cache[40] = ($event: any) => (_ctx.advMatchSetRoundsModeStateChanged($event)))
        }, null, 8, ["readOnlyFlag", "playerToStartFirstRound", "submatchWinAtNumberOfWonSets", "matchIndexNumber", "matchSet", "matchId", "playerTeamNames", "matchTeamPlayersNames", "matchTeamSecondPlayersNames", "matchIsDouble", "selectedMatchId", "homeTeamResult", "awayTeamResult", "tournamentCategoryId"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.showUpdateRefreshProgressModal,
      "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.showUpdateRefreshProgressModal) = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      size: "medium",
      "no-dismiss": ""
    }, {
      header: _withCtx(() => [
        _hoisted_198
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_199, [
          _createElementVNode("div", _hoisted_200, [
            _createElementVNode("div", _hoisted_201, [
              _createVNode(_component_va_progress_bar, {
                "model-value": _ctx.countdownValue,
                size: "large",
                "content-inside": ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.countdownValue / 10), 1)
                ]),
                _: 1
              }, 8, ["model-value"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.matchTeamResetWarningModal,
      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.matchTeamResetWarningModal) = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      size: "small"
    }, {
      header: _withCtx(() => [
        _hoisted_202
      ]),
      default: _withCtx(() => [
        _hoisted_203
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_204, [
          _createElementVNode("div", _hoisted_205, [
            _createElementVNode("div", _hoisted_206, [
              _createVNode(_component_va_button, {
                color: "danger",
                onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.matchTeamResetWarningModal = false, _ctx.resetTeam()))
              }, {
                default: _withCtx(() => [
                  _hoisted_207
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_208, [
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.matchTeamResetWarningModal = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_209
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.match180WriteOnlyModeValueChangeToTrueWarningModal,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.match180WriteOnlyModeValueChangeToTrueWarningModal) = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.5",
      size: "small"
    }, {
      header: _withCtx(() => [
        _hoisted_210
      ]),
      default: _withCtx(() => [
        _hoisted_211
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_212, [
          _createElementVNode("div", _hoisted_213, [
            _createElementVNode("div", _hoisted_214, [
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.match180WriteOnlyModeValueChangeToTrueWarningModal = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_215
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.playerLegalityModal,
      "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.playerLegalityModal) = $event))
    }, {
      header: _withCtx(() => [
        _createElementVNode("h6", _hoisted_216, _toDisplayString(_ctx.playerLegalityHeadline), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_217, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playersLegalityArray, (player, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row justify--center",
              key: index
            }, [
              _createElementVNode("div", _hoisted_218, [
                _createVNode(_component_va_icon, {
                  name: player.legalBol ? 'check_circle' : 'warning',
                  color: player.legalBol ? 'success' : 'warning'
                }, null, 8, ["name", "color"])
              ]),
              _createElementVNode("div", _hoisted_219, [
                _createElementVNode("p", null, _toDisplayString(player.legalString), 1)
              ])
            ]))
          }), 128))
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_220, [
          _createElementVNode("div", _hoisted_221, [
            (_ctx.bothTeamSet())
              ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                  (_ctx.loadingStatusBegyndkamp)
                    ? (_openBlock(), _createBlock(_component_LoadingButton, {
                        key: 0,
                        color: "success"
                      }))
                    : (_openBlock(), _createBlock(_component_va_button, {
                        key: 1,
                        color: "success",
                        onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.reMapPlayers())),
                        disabled: !_ctx.setupMatchSettlementTeamPlayersExtDataCompletede || (_ctx.matchExecution.kampafvikling_ekstras_id !== undefined && _ctx.matchExecution.kampafvikling_ekstras_id.length > 0) || _ctx.match?.homeTeamCaptain === null || _ctx.match?.awayTeamCaptain === null
                      }, {
                        default: _withCtx(() => [
                          _hoisted_223
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_224, [
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.playerLegalityModal = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_225
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.teamCaptainSelectionModel,
      "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.teamCaptainSelectionModel) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_226
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_227, [
          _createElementVNode("div", _hoisted_228, [
            _createVNode(_component_va_select, {
              modelValue: _ctx.homeTeamCaptain,
              "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.homeTeamCaptain) = $event)),
              label: "Hjemmehold",
              placeholder: "Vælg holdkaptajn for hjemmehold",
              options: _ctx.homeTeamArray,
              "track-by": (v) => v.id,
              "text-by": (v) => v.name,
              isOpen: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"]),
            _createVNode(_component_va_select, {
              modelValue: _ctx.awayTeamCaptain,
              "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.awayTeamCaptain) = $event)),
              label: "Udehold",
              placeholder: "Vælg holdkaptajn for udehold",
              options: _ctx.awayTeamArray,
              "track-by": (v) => v.id,
              "text-by": (v) => v.name,
              isOpen: ""
            }, null, 8, ["modelValue", "options", "track-by", "text-by"])
          ])
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_229, [
          _createElementVNode("div", _hoisted_230, [
            _createElementVNode("div", _hoisted_231, [
              (_ctx.loadingStatus)
                ? (_openBlock(), _createBlock(_component_LoadingButton, {
                    key: 0,
                    color: "success"
                  }))
                : (_openBlock(), _createBlock(_component_va_button, {
                    key: 1,
                    color: "success",
                    onClick: _cache[53] || (_cache[53] = ($event: any) => (_ctx.setTeamCaptains())),
                    disabled: _ctx.homeTeamCaptain === null || _ctx.awayTeamCaptain === null
                  }, {
                    default: _withCtx(() => [
                      _hoisted_232
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
            ]),
            _createElementVNode("div", _hoisted_233, [
              _createVNode(_component_va_button, {
                color: "secondary",
                onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.teamCaptainSelectionModel = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_234
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_it_modal, {
      modelValue: _ctx.finishMatchModal,
      "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.finishMatchModal) = $event))
    }, {
      header: _withCtx(() => [
        _hoisted_235
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_236, [
          _createElementVNode("div", _hoisted_237, [
            _createElementVNode("div", _hoisted_238, [
              _hoisted_239,
              _hoisted_240,
              _hoisted_241,
              _hoisted_242,
              _createElementVNode("div", _hoisted_243, [
                _createVNode(_component_va_button, {
                  class: "center",
                  onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.reloadPage())),
                  color: "default"
                }, {
                  default: _withCtx(() => [
                    _hoisted_244
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_245, [
                _createVNode(_component_va_divider)
              ])
            ])
          ]),
          (_ctx.matchSetCheckupMsg.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_246, _hoisted_248))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.matchSetCheckupMsg, (checkupMsgItem, msgindex) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "row",
              key: msgindex
            }, [
              _createElementVNode("div", _hoisted_249, _toDisplayString(checkupMsgItem), 1)
            ]))
          }), 128)),
          _hoisted_250,
          _hoisted_251,
          (_ctx.protestValue !== 'Ingen')
            ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                _createElementVNode("div", _hoisted_253, [
                  _createElementVNode("p", _hoisted_254, [
                    _hoisted_255,
                    _createElementVNode("b", null, _toDisplayString(_ctx.protestValue), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_256, [
                  _createVNode(_component_va_input, {
                    type: "textarea",
                    modelValue: _ctx.protestComment,
                    "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.protestComment) = $event)),
                    rows: 10,
                    label: "Tilføjelser til bemærkning"
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.matchSetCheckupMsg.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_257, [
                _createElementVNode("div", _hoisted_258, [
                  _createVNode(_component_va_checkbox, {
                    class: "mb-6",
                    modelValue: _ctx.ignoreErrorsInMatchSetsFlag,
                    "onUpdate:modelValue": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.ignoreErrorsInMatchSetsFlag) = $event)),
                    label: "Ignorer fejl og fortsæt alligevel",
                    disabled: true,
                    hide: ""
                  }, null, 8, ["modelValue"])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_259, [
          _createElementVNode("div", _hoisted_260, [
            _createVNode(_component_va_button, {
              class: "mr-4",
              onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.finishMatch())),
              color: "success",
              disabled: (!_ctx.ignoreErrorsInMatchSetsFlag && _ctx.matchSetCheckupMsg.length > 0)
            }, {
              default: _withCtx(() => [
                _hoisted_261
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_va_button, {
              class: "ml-4",
              onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.finishMatchModal = false)),
              color: "secondary"
            }, {
              default: _withCtx(() => [
                _hoisted_262
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_va_modal, {
      modelValue: _ctx.selectTeamModal,
      "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.selectTeamModal) = $event)),
      "hide-default-actions": "",
      "overlay-opacity": "0.5"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_278, [
          _createElementVNode("div", _hoisted_279, [
            _withDirectives(_createVNode(_component_va_button, {
              class: "mr-2",
              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.finishSettingTeam())),
              color: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_280
              ]),
              _: 1
            }, 512), [
              [_vShow, (_ctx.settingAwayTeam ? _ctx.awayTeamArray.length : _ctx.homeTeamArray.length) >= _ctx.matchRules.minPlayers]
            ]),
            _createVNode(_component_va_button, {
              class: "ml-2",
              color: "secondary",
              onClick: _cache[65] || (_cache[65] = ($event: any) => (_ctx.selectTeamModal = false))
            }, {
              default: _withCtx(() => [
                _hoisted_281
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_263, _toDisplayString(_ctx.settingAwayTeam ? 'Sæt udehold' : 'Sæt hjemmehold'), 1),
        _createElementVNode("div", _hoisted_264, [
          _createElementVNode("div", _hoisted_265, [
            _createElementVNode("div", _hoisted_266, [
              _createVNode(_component_va_select, {
                modelValue: _ctx.playerValue,
                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.playerValue) = $event)),
                options: (_ctx.settingAwayTeam ? _ctx.awayTeamOptions : _ctx.homeTeamOptions),
                "track-by": (v) => v.id,
                "text-by": (v) => v.name,
                label: "Spillere",
                searchable: "",
                "stick-to-edges": "",
                bordered: ""
              }, null, 8, ["modelValue", "options", "track-by", "text-by"])
            ]),
            _createElementVNode("div", _hoisted_267, [
              _createVNode(_component_va_button, {
                color: "success",
                onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.addPlayerToTeam()))
              }, {
                default: _withCtx(() => [
                  _hoisted_268
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_269, [
              _createVNode(_component_va_chip, {
                size: "large",
                color: (_ctx.settingAwayTeam ? _ctx.awayTeamArray.length : _ctx.homeTeamArray.length) >= _ctx.matchRules.minPlayers ? 'success' : 'warning'
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString('Spillere valgt: ' + (_ctx.settingAwayTeam ? _ctx.awayTeamArray.length : _ctx.homeTeamArray.length) + '/' + _ctx.matchRules.maxPlayers), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ])
          ]),
          _createVNode(_component_va_divider),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.settingAwayTeam ? _ctx.awayTeamArray : _ctx.homeTeamArray), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "row justify--center"
            }, [
              _createElementVNode("div", _hoisted_270, [
                (index > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "settingTeamBtn",
                      onClick: ($event: any) => (_ctx.movePlayerPosition(_ctx.settingAwayTeam, index, -1))
                    }, [
                      _createVNode(_component_va_icon, {
                        name: "keyboard_double_arrow_up",
                        color: "success"
                      })
                    ], 8, _hoisted_271))
                  : _createCommentVNode("", true),
                (index < (_ctx.settingAwayTeam ? _ctx.awayTeamArray.length - 1: _ctx.homeTeamArray.length - 1))
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "settingTeamBtn",
                      onClick: ($event: any) => (_ctx.movePlayerPosition(_ctx.settingAwayTeam, index, 1))
                    }, [
                      _createVNode(_component_va_icon, {
                        name: "keyboard_double_arrow_down",
                        color: "success"
                      })
                    ], 8, _hoisted_272))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_273, [
                _createElementVNode("p", _hoisted_274, _toDisplayString((_ctx.settingAwayTeam ? String.fromCharCode(index +65).toString() : (index +1).toString()) + '.'), 1)
              ]),
              _createElementVNode("div", _hoisted_275, [
                _createElementVNode("p", null, _toDisplayString(item.name), 1)
              ]),
              _createElementVNode("div", _hoisted_276, [
                _createElementVNode("button", {
                  class: "settingTeamBtn",
                  onClick: ($event: any) => (_ctx.removePlayer(_ctx.settingAwayTeam, index))
                }, [
                  _createVNode(_component_va_icon, {
                    name: "clear",
                    color: "danger"
                  })
                ], 8, _hoisted_277)
              ])
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_vue3_html2pdf, {
      "show-layout": false,
      "float-layout": true,
      "preview-modal": true,
      "enable-download": false,
      "paginate-elements-by-height": 3300,
      filename: 'test',
      "pdf-quality": 2,
      "manual-pagination": false,
      "pdf-format": "a4",
      "pdf-orientation": "portrait",
      "pdf-content-width": "100%",
      onProgress: _cache[67] || (_cache[67] = ($event: any) => (_ctx.onHtml2PDFProgress($event))),
      ref: "matchCard"
    }, _createSlots({ _: 2 }, [
      (_ctx.match !== undefined && _ctx.match.id !== undefined)
        ? {
            name: "pdf-content",
            fn: _withCtx(() => [
              _createElementVNode("section", _hoisted_282, [
                _hoisted_283,
                _createElementVNode("table", _hoisted_284, [
                  _createElementVNode("tr", _hoisted_285, [
                    _createElementVNode("td", _hoisted_286, [
                      _createElementVNode("p", _hoisted_287, "Kamp-nr.: " + _toDisplayString(_ctx.match.kampprogram_kampnr), 1)
                    ]),
                    _createElementVNode("td", _hoisted_288, [
                      _createElementVNode("p", _hoisted_289, "Række: " + _toDisplayString(_ctx.match.raekke_id.raekke_navn), 1)
                    ]),
                    _hoisted_290
                  ]),
                  _createElementVNode("tr", _hoisted_291, [
                    _createElementVNode("td", _hoisted_292, [
                      _createElementVNode("p", _hoisted_293, "Kampdato: " + _toDisplayString(_ctx.match.kampprogram_nydato === null ? _ctx.getDanishDate(_ctx.match.kampprogram_dato) : _ctx.getDanishDate(_ctx.match.kampprogram_nydato)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_294, [
                      _createElementVNode("p", _hoisted_295, "Hjemmehold: " + _toDisplayString(_ctx.match.kampprogram_hjemmehold.hold_holdnavn), 1)
                    ]),
                    _createElementVNode("td", _hoisted_296, [
                      _createElementVNode("p", _hoisted_297, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? _ctx.matchExecution.kampafvikling_resultat_hjem.toString() : '')), 1)
                    ])
                  ]),
                  _createElementVNode("tr", _hoisted_298, [
                    _createElementVNode("td", _hoisted_299, [
                      _createElementVNode("p", _hoisted_300, "Kampstart: kl. " + _toDisplayString(_ctx.match.kampprogram_nydato === null ? _ctx.getTime(_ctx.match.kampprogram_dato) : _ctx.getTime(_ctx.match.kampprogram_nydato)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_301, [
                      _createElementVNode("p", _hoisted_302, "Udehold: " + _toDisplayString(_ctx.match.kampprogram_udehold.hold_holdnavn), 1)
                    ]),
                    _createElementVNode("td", _hoisted_303, [
                      _createElementVNode("p", _hoisted_304, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? _ctx.matchExecution.kampafvikling_resultat_ude.toString() : '')), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_305, [
                _hoisted_306,
                _createElementVNode("table", _hoisted_307, [
                  _hoisted_308,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.matchCardOutputMode === 0 ? _ctx.homePlayersEmptyInfoData.filter(el => !el.hide) : _ctx.homePlayersInfoData.filter(el => !el.hide)), (homeTeam, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "pdfPlayerTr",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_309, [
                        _createElementVNode("p", _hoisted_310, _toDisplayString(index +1 + '. ' + homeTeam.name), 1)
                      ]),
                      _createElementVNode("td", _hoisted_311, [
                        (_ctx.matchCardOutputMode === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_312))
                          : (_openBlock(), _createElementBlock("p", _hoisted_313, _toDisplayString(homeTeam.license), 1))
                      ]),
                      _createElementVNode("td", _hoisted_314, [
                        _createElementVNode("p", _hoisted_315, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? homeTeam.matchesWon : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_316, [
                        _createElementVNode("p", _hoisted_317, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? homeTeam.matchSetsWon : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_318, [
                        _createElementVNode("p", _hoisted_319, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? homeTeam.matchSetsLost : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_320, [
                        _createElementVNode("p", _hoisted_321, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? homeTeam.match180 : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_322, [
                        _createElementVNode("p", _hoisted_323, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? homeTeam.matchSetHighestClosing : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_324, [
                        _createElementVNode("p", _hoisted_325, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? homeTeam.matchSetFastestDarting : '')), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("section", _hoisted_326, [
                _hoisted_327,
                _createElementVNode("table", _hoisted_328, [
                  _hoisted_329,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.matchCardOutputMode === 0 ? _ctx.awayPlayersEmptyInfoData.filter(el => !el.hide) : _ctx.awayPlayersInfoData.filter(el => !el.hide)), (awayTeam, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: "pdfPlayerTr",
                      key: index
                    }, [
                      _createElementVNode("td", _hoisted_330, [
                        _createElementVNode("p", _hoisted_331, _toDisplayString(String.fromCharCode(index + 65) + '. ' + awayTeam.name), 1)
                      ]),
                      _createElementVNode("td", _hoisted_332, [
                        (_ctx.matchCardOutputMode === 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_333))
                          : (_openBlock(), _createElementBlock("p", _hoisted_334, _toDisplayString(awayTeam.license), 1))
                      ]),
                      _createElementVNode("td", _hoisted_335, [
                        _createElementVNode("p", _hoisted_336, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? awayTeam.matchesWon : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_337, [
                        _createElementVNode("p", _hoisted_338, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? awayTeam.matchSetsWon : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_339, [
                        _createElementVNode("p", _hoisted_340, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? awayTeam.matchSetsLost : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_341, [
                        _createElementVNode("p", _hoisted_342, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? awayTeam.match180 : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_343, [
                        _createElementVNode("p", _hoisted_344, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? awayTeam.matchSetHighestClosing : '')), 1)
                      ]),
                      _createElementVNode("td", _hoisted_345, [
                        _createElementVNode("p", _hoisted_346, _toDisplayString((_ctx.matchPlayed && _ctx.matchCardOutputMode === 1 ? awayTeam.matchSetFastestDarting : '')), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              ((_ctx.matchCardOutputMode === 0 ? (_ctx.emptyMatchesCreated === _ctx.numberOfMatches && _ctx.emptySetsCreated === _ctx.numberOfSets * _ctx.numberOfMatches) : (_ctx.matchesCreated === _ctx.numberOfMatches && _ctx.setsCreated === _ctx.numberOfSets * _ctx.numberOfMatches)))
                ? (_openBlock(), _createElementBlock("section", _hoisted_347, [
                    (_ctx.matchCardOutputMode === 0)
                      ? (_openBlock(), _createElementBlock("table", _hoisted_348, [
                          _createElementVNode("tr", _hoisted_349, [
                            _hoisted_350,
                            _hoisted_351,
                            _createElementVNode("td", _hoisted_352, [
                              _createVNode(_component_va_icon, {
                                name: "done",
                                size: "10px"
                              })
                            ]),
                            _hoisted_353,
                            _hoisted_354,
                            _hoisted_355,
                            _hoisted_356,
                            _hoisted_357,
                            _hoisted_358,
                            _createElementVNode("td", _hoisted_359, [
                              _createVNode(_component_va_icon, {
                                name: "done",
                                size: "10px"
                              })
                            ]),
                            _hoisted_360
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAUXMatchData(), (row, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              class: "pdfMatchTr"
                            }, [
                              _createElementVNode("td", _hoisted_361, _toDisplayString(index + 1), 1),
                              (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer2 === undefined || row.matchHomeTeamPlayer2 === null)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_362, "-"))
                                : (_openBlock(), _createElementBlock("td", _hoisted_363, [
                                    _createTextVNode(_toDisplayString((row.matchHomeTeamPlayer === '9' ? '' : row.matchHomeTeamPlayer + ' ' + row.matchHomeTeamPlayerName)), 1),
                                    _hoisted_364,
                                    _createTextVNode(_toDisplayString((row.matchHomeTeamPlayer2 === '9' ? '' : row.matchHomeTeamPlayer2 + ' ' + row.matchHomeTeamPlayer2Name)), 1),
                                    _hoisted_365,
                                    _createTextVNode(_toDisplayString((row.matchHomeScoreResultRecorder === null ? '' : (row.matchHomeScoreResultRecorder === '0' ? '*' : '* (' + row.matchHomeScoreResultRecorder + ')'))), 1),
                                    _hoisted_366
                                  ])),
                              _hoisted_367,
                              (_ctx.emptySetsCreated !== _ctx.numberOfSets * _ctx.numberOfMatches)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_368, "-"))
                                : (_openBlock(), _createElementBlock("td", _hoisted_369, [
                                    _createElementVNode("table", _hoisted_370, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.match.raekke_id.raekke_antalsaet, (index2) => {
                                        return (_openBlock(), _createElementBlock("tr", { key: index2 }, _hoisted_377))
                                      }), 128))
                                    ])
                                  ])),
                              _hoisted_378,
                              (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer2 === undefined || row.matchGuestTeamPlayer2 === null)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_379, "-"))
                                : (_openBlock(), _createElementBlock("td", _hoisted_380, [
                                    _createTextVNode(_toDisplayString((row.matchGuestTeamPlayer === 'Z' ? '' : row.matchGuestTeamPlayer + ' ' + row.matchGuestTeamPlayerName)), 1),
                                    _hoisted_381,
                                    _createTextVNode(_toDisplayString((row.matchGuestTeamPlayer2 === 'Z' ? '' : row.matchGuestTeamPlayer2 + ' ' + row.matchGuestTeamPlayer2Name)), 1),
                                    _hoisted_382,
                                    _createTextVNode(_toDisplayString((row.matchGuestScoreResultRecorder === null ? '' : (row.matchGuestScoreResultRecorder === '0' ? '*' : '* (' + row.matchGuestScoreResultRecorder + ')'))), 1),
                                    _hoisted_383
                                  ]))
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("table", _hoisted_384, [
                          _createElementVNode("tr", _hoisted_385, [
                            _hoisted_386,
                            _hoisted_387,
                            _createElementVNode("td", _hoisted_388, [
                              _createVNode(_component_va_icon, {
                                name: "done",
                                size: "10px"
                              })
                            ]),
                            _hoisted_389,
                            _hoisted_390,
                            _hoisted_391,
                            _hoisted_392,
                            _hoisted_393,
                            _hoisted_394,
                            _createElementVNode("td", _hoisted_395, [
                              _createVNode(_component_va_icon, {
                                name: "done",
                                size: "10px"
                              })
                            ]),
                            _hoisted_396
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMatchData(), (row, index) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: index,
                              class: "pdfMatchTr"
                            }, [
                              _createElementVNode("td", _hoisted_397, _toDisplayString(index + 1), 1),
                              (row.matchHomeTeamPlayer === undefined || row.matchHomeTeamPlayer === null || row.matchHomeTeamPlayer2 === undefined || row.matchHomeTeamPlayer2 === null)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_398, "-"))
                                : (_openBlock(), _createElementBlock("td", _hoisted_399, [
                                    _createTextVNode(_toDisplayString((row.matchHomeTeamPlayer === '9' ? '' : row.matchHomeTeamPlayer + ' ' + row.matchHomeTeamPlayerName)), 1),
                                    _hoisted_400,
                                    _createTextVNode(_toDisplayString((row.matchHomeTeamPlayer2 === '9' ? '' : row.matchHomeTeamPlayer2 + ' ' + row.matchHomeTeamPlayer2Name)), 1),
                                    _hoisted_401,
                                    _createTextVNode(_toDisplayString((row.matchHomeScoreResultRecorder === null ? '' : (row.matchHomeScoreResultRecorder === '0' ? '*' : '* (' + row.matchHomeScoreResultRecorder + ')'))), 1),
                                    _hoisted_402
                                  ])),
                              _hoisted_403,
                              (_ctx.setsCreated !== _ctx.numberOfSets * _ctx.numberOfMatches)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_404, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.match.raekke_id.raekke_antalsaet, (index2) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "match-grid",
                                        key: index2
                                      }, _hoisted_411))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("td", _hoisted_412, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.match.raekke_id.raekke_antalsaet, (match, index2) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        class: "match-grid",
                                        key: match.id
                                      }, [
                                        _createElementVNode("div", _hoisted_413, _toDisplayString(_ctx.getSetResultsData((index + 1))[index2 * 2].matchSetRemainScore === 0 ? '​' : _ctx.getSetResultsData((index + 1))[index2 * 2].matchSetRemainScore), 1),
                                        _createElementVNode("div", _hoisted_414, _toDisplayString(_ctx.getSetResultsData((index + 1))[index2 * 2].matchSetDart === 0 ? '​' : _ctx.getSetResultsData((index + 1))[index2 * 2].matchSetDart), 1),
                                        _createElementVNode("div", _hoisted_415, _toDisplayString(_ctx.getSetResultsData((index + 1))[index2 * 2].matchSetClosed === 0 ? '​' : _ctx.getSetResultsData((index + 1))[index2 * 2].matchSetClosed), 1),
                                        _createElementVNode("div", _hoisted_416, _toDisplayString(_ctx.getSetResultsData((index + 1))[index2 * 2 + 1].matchSetRemainScore === 0 ? '​' : _ctx.getSetResultsData((index + 1))[index2 * 2 + 1].matchSetRemainScore), 1),
                                        _createElementVNode("div", _hoisted_417, _toDisplayString(_ctx.getSetResultsData((index + 1))[index2 * 2 + 1].matchSetDart === 0 ? '​' : _ctx.getSetResultsData((index + 1))[index2 * 2 + 1].matchSetDart), 1),
                                        _createElementVNode("div", _hoisted_418, _toDisplayString(_ctx.getSetResultsData((index + 1))[index2 * 2 + 1].matchSetClosed === 0 ? '​' : _ctx.getSetResultsData((index + 1))[index2 * 2 + 1].matchSetClosed), 1)
                                      ]))
                                    }), 128))
                                  ])),
                              _hoisted_419,
                              (row.matchGuestTeamPlayer === undefined || row.matchGuestTeamPlayer === null || row.matchGuestTeamPlayer2 === undefined || row.matchGuestTeamPlayer2 === null)
                                ? (_openBlock(), _createElementBlock("td", _hoisted_420, "-"))
                                : (_openBlock(), _createElementBlock("td", _hoisted_421, [
                                    _createTextVNode(_toDisplayString((row.matchGuestTeamPlayer === 'Z' ? '' : row.matchGuestTeamPlayer + ' ' + row.matchGuestTeamPlayerName)), 1),
                                    _hoisted_422,
                                    _createTextVNode(_toDisplayString((row.matchGuestTeamPlayer2 === 'Z' ? '' : row.matchGuestTeamPlayer2 + ' ' + row.matchGuestTeamPlayer2Name)), 1),
                                    _hoisted_423,
                                    _createTextVNode(_toDisplayString((row.matchGuestScoreResultRecorder === null ? '' : (row.matchGuestScoreResultRecorder === '0' ? '*' : '* (' + row.matchGuestScoreResultRecorder + ')'))), 1),
                                    _hoisted_424
                                  ]))
                            ]))
                          }), 128))
                        ]))
                  ]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1536)
  ]))
}